import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { InlineCalendarStyles } from "./inlineCalendar.styles";

const InlineCalendar = ({ value, onChange, minDate }) => (
  <InlineCalendarStyles>
    <DatePicker
      selected={value}
      onChange={onChange}
      minDate={minDate}
      inline
    />
  </InlineCalendarStyles>
);

export default InlineCalendar;
